/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Team_Manager_Remove_User_FailedInputs */

const en_team_manager_remove_user_failed = /** @type {(inputs: Team_Manager_Remove_User_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to remove user from team. ${i?.error}`)
};

const fr_team_manager_remove_user_failed = /** @type {(inputs: Team_Manager_Remove_User_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de la suppression de l’utilisateur de l’équipe. ${i?.error}`)
};

const de_team_manager_remove_user_failed = /** @type {(inputs: Team_Manager_Remove_User_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Benutzer konnte nicht aus dem Team entfernt werden. ${i?.error}`)
};

const it_team_manager_remove_user_failed = /** @type {(inputs: Team_Manager_Remove_User_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile rimuovere l'utente dal team. ${i?.error}`)
};

const ru_team_manager_remove_user_failed = /** @type {(inputs: Team_Manager_Remove_User_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось удалить пользователя из команды. ${i?.error}`)
};

const es_team_manager_remove_user_failed = /** @type {(inputs: Team_Manager_Remove_User_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo eliminar el usuario del equipo. ${i?.error}`)
};

const zh_cn2_team_manager_remove_user_failed = /** @type {(inputs: Team_Manager_Remove_User_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`无法将用户从团队中移除。${i?.error}`)
};

const ja_team_manager_remove_user_failed = /** @type {(inputs: Team_Manager_Remove_User_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`チームからユーザーを削除できませんでした。${i?.error}`)
};

const hi_team_manager_remove_user_failed = /** @type {(inputs: Team_Manager_Remove_User_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`टीम से उपयोगकर्ता को हटाने में विफल। ${i?.error}`)
};

const pt_pt2_team_manager_remove_user_failed = /** @type {(inputs: Team_Manager_Remove_User_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao remover o usuário da equipe. ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to remove user from team. {error}" |
*
* @param {Team_Manager_Remove_User_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_remove_user_failed = /** @type {((inputs: Team_Manager_Remove_User_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Remove_User_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_remove_user_failed(inputs)
	if (locale === "de") return de_team_manager_remove_user_failed(inputs)
	if (locale === "it") return it_team_manager_remove_user_failed(inputs)
	if (locale === "ru") return ru_team_manager_remove_user_failed(inputs)
	if (locale === "es") return es_team_manager_remove_user_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_remove_user_failed(inputs)
	if (locale === "ja") return ja_team_manager_remove_user_failed(inputs)
	if (locale === "hi") return hi_team_manager_remove_user_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_remove_user_failed(inputs)
	return en_team_manager_remove_user_failed(inputs)
});